import { ConjugationButton } from './ConjugationButton';
import React, { useContext } from 'react';
import TextInput from '../../../../CMFW/input/TextInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import ModuleContext from 'CMFW/context/ModuleContext';
import KeyContext from 'CMFW/context/KeyContext';
import { createKeyPath } from 'CMFW/context/helper/keyContext';
import InflectsModel, { IConjugationState } from 'models/InflectsModel';

const InflectTableCellInflectConj: React.FC = () => {
  const inflectsModel = useContext(ModuleContext) as InflectsModel;
  const parentKey = useContext(KeyContext);

  // Get the active property from the inflect data
  const isActive = inflectsModel.getItemUpdatedValue.bind(inflectsModel)(createKeyPath(parentKey, 'active')) ?? true;
  const conjLockState =
    inflectsModel.getItemUpdatedValue.bind(inflectsModel)(createKeyPath(parentKey, 'conjLockState')) ??
    IConjugationState.NO_CONJ;
  const isManualConjugation = conjLockState === IConjugationState.LOCK_NO_CONJ;

  if (!isActive) {
    return (
      <InactiveCellContainer>
        <InactiveIndicator>
          <FontAwesomeIcon icon={faTimes} />
        </InactiveIndicator>
      </InactiveCellContainer>
    );
  }

  return (
    <CellContainer>
      <Row>
        <ConjugationButton />
        <InputWrapper>
          <TextInput keyName={'word'} />
        </InputWrapper>
      </Row>
      {isManualConjugation && (
        <ManualInputWrapper>
          <TextInput keyName={'conjWord'} placeholder="Manual conjugation" />
        </ManualInputWrapper>
      )}
    </CellContainer>
  );
};

const CellContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
`;

const InputWrapper = styled.div`
  flex: 1;
  min-width: 0;
  margin-left: 6px;

  input {
    width: 100%;
    padding: 4px 8px;
    font-size: 14px;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    transition: border-color 0.2s ease;

    &:focus {
      outline: none;
      border-color: #3b82f6;
    }
  }
`;

const ManualInputWrapper = styled(InputWrapper)`
  margin-left: 20px;
`;

const InactiveCellContainer = styled.div`
  position: relative;
  width: 100%;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const InactiveIndicator = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 14px;
  height: 14px;
  color: #6b7280;
  opacity: 0.2;
`;

export default InflectTableCellInflectConj;
